export default __webpack_public_path__ + "static/media/GoTop.c21e2377.svg";